module.exports = __webpack_public_path__ + "media/packs/images/flags/NG-30b8b5fe401c615f0a8798fd149f6882.png";